export const routePaths = {
  SignIn: '/',
  SignUp: '/signup',
  Dashboard: '/dashboard',
  People: '/people',
  Favorites: '/favorites',
  FamilyTree: '/family-tree',
  SharedFamilyTree: '/shared-family-tree',
  FamilyTreeImport: '/family-tree/import',
  Memories: '/memories',
  Recipes: '/recipes',
  Sharing: '/sharing',
  Notifications: '/notifications',
  Storages: '/storage',
  Trash: '/trash',
  Tutorial: '/tutorial',
  ForgotPassword: '/forgot-password',
  ResetPassword: '/reset-password',
  TwoFactorAuthentication: '/two-factor-authentication',
  Subscription: '/subscription',
  SelectedSubscription: '/selected-subscription',
  PaymentSuccess: '/payment-success',
  MyProfile: '/my-profile',
  EditProfile: '/my-profile/edit',
  Camera: '/my-profile/camera',
  SecurityPrivacy: '/settings/security-privacy',
  Payments: '/payments',
  Notification: '/settings/notification',
  Help: '/settings/help',
  ManageSubscriptions: '/settings/subscriptions/manage',
  SettingSubscription: '/settings/subscriptions',
  ContributorStorage: '/settings/subscriptions/manage/photos',
  Photos: '/photos',
  MediaView: '/photos/media',
  TakeAPhoto: '/photos/camera',
  PaymentsSettings: '/settings/payments',
  Storage: '/settings/storage',
  Folders: '/photo/folders',
  Friends: '/people/friends',
  Family: '/people/family',
  RecipeFolders: '/recipes/folder',
  FavoriteViewAll: '/favorites/view',
  TrashViewAll: '/trash/view',
  SetPasswordRequest: '/set-password/request',
  PendingContributions: '/photos/contributions',
  SharingGroupDetail: '/sharing/groups',
  PrivacyPolicy: '/privacy-policy',
  TermsAndConditions: '/terms-and-conditions'
};

export const adminRoutePaths = {
  AdminHome: '/admin',
  UserDirectory: '/admin/user-management/user-directory',
  UserSegmentation: '/admin/user-management/user-segmentation',
  UserSegmentationUsers: '/admin/user-management/user-segmentation/:segmentKey',
  AIModeration: '/admin/content-moderation/ai-moderation',
  AccountLevelAlerts: '/admin/content-moderation/account-level-alerts',
  ManualReview: '/admin/content-moderation/manual-review',
  ContentFlagging: '/admin/content-moderation/content-flagging',
  SubscriptionDashboard:
    '/admin/subscription-management/subscription-dashboard',
  AdminSubscriptionList: '/admin/subscription-management/subscription-list',
  TierManagement: '/admin/subscription-management/tier-management',
  SubscriptionAnalytics: '/admin/subscription-management/analytics',
  AnalyticsOverview: '/admin/analytics/overview',
  SalesAndRevenue: '/admin/analytics/sales-revenue',
  ProductPerformance: '/admin/analytics/product-performance',
  AdminUsers: '/admin/system-admin/admin-users',
  SystemSettings: '/admin/system-admin/system-settings',
  Integrations: '/admin/system-admin/integrations',
  StorageManagement: '/admin/security/storage-management',
  DownloadManagement: '/admin/security/download-management',
  Tutorials: '/admin/tutorials',
  PaymentsAndBilling: '/admin/financial/payments-billing',
  FinancialAnalytics: '/admin/financial/analytics',
  CustomerReports: '/admin/customer-analytics/customer-reports',
  CohortAnalysis: '/admin/customer-analytics/cohort-analysis',
  LifetimeValue: '/admin/customer-analytics/lifetime-value',
  EngagementMetrics: '/admin/customer-analytics/engagement-metrics'
} as const;
